export default "__VITE_ASSET__CPYd229t__"